var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "login-form-container" }, [
    _c(
      "form",
      {
        staticClass: "login-form",
        attrs: { id: "modules-login-form", "data-abide": "", novalidate: "" },
        on: {
          submit: function ($event) {
            $event.preventDefault()
          },
          mouseover: function () {
            return _vm.validate()
          },
        },
      },
      [
        _c("div", { staticClass: "welcome-panel" }, [
          _c("a", [_vm._v(_vm._s(_vm.$t("loginForm.welcome")))]),
        ]),
        _vm._v(" "),
        _vm.isAdMock
          ? [
              _c("div", { staticClass: "small-12 columns  info-input" }, [
                _c("label", [
                  _vm._v(
                    "\n          " + _vm._s(_vm.$t("username")) + "\n          "
                  ),
                  _c("div", { staticClass: "email-input-container" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.username,
                          expression: "username",
                        },
                      ],
                      staticClass: "email-input",
                      attrs: {
                        id: "modules-login-form-input-username",
                        type: "text",
                        name: "username",
                        placeholder: _vm.$t("username"),
                        required: "",
                      },
                      domProps: { value: _vm.username },
                      on: {
                        input: [
                          function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.username = $event.target.value
                          },
                          _vm.validate,
                        ],
                      },
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "email-sufix" }, [
                      _vm._v(_vm._s(_vm.hkldSuffix)),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "form-error" }, [
                    _vm._v(_vm._s(_vm.$t("loginForm.usernameTip"))),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "small-12 columns info-input" }, [
                _c(
                  "label",
                  { attrs: { for: "modules-login-form-input-password" } },
                  [
                    _vm._v(
                      "\n          " + _vm._s(_vm.$t("password")) + "\n        "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "password-input-container" }, [
                  (_vm.isPasswordVisible ? "text" : "password") === "checkbox"
                    ? _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.password,
                            expression: "password",
                          },
                        ],
                        staticClass: "text-input password-input",
                        attrs: {
                          id: "modules-login-form-input-password",
                          name: "password",
                          placeholder: _vm.$t("password"),
                          pattern: ".{6,}",
                          required: "",
                          type: "checkbox",
                        },
                        domProps: {
                          checked: Array.isArray(_vm.password)
                            ? _vm._i(_vm.password, null) > -1
                            : _vm.password,
                        },
                        on: {
                          input: _vm.validate,
                          change: function ($event) {
                            var $$a = _vm.password,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 && (_vm.password = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (_vm.password = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.password = $$c
                            }
                          },
                        },
                      })
                    : (_vm.isPasswordVisible ? "text" : "password") === "radio"
                    ? _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.password,
                            expression: "password",
                          },
                        ],
                        staticClass: "text-input password-input",
                        attrs: {
                          id: "modules-login-form-input-password",
                          name: "password",
                          placeholder: _vm.$t("password"),
                          pattern: ".{6,}",
                          required: "",
                          type: "radio",
                        },
                        domProps: { checked: _vm._q(_vm.password, null) },
                        on: {
                          input: _vm.validate,
                          change: function ($event) {
                            _vm.password = null
                          },
                        },
                      })
                    : _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.password,
                            expression: "password",
                          },
                        ],
                        staticClass: "text-input password-input",
                        attrs: {
                          id: "modules-login-form-input-password",
                          name: "password",
                          placeholder: _vm.$t("password"),
                          pattern: ".{6,}",
                          required: "",
                          type: _vm.isPasswordVisible ? "text" : "password",
                        },
                        domProps: { value: _vm.password },
                        on: {
                          input: [
                            function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.password = $event.target.value
                            },
                            _vm.validate,
                          ],
                        },
                      }),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "password-visibility-toggle",
                      attrs: {
                        type: "button",
                        "aria-label": _vm.isPasswordVisible
                          ? "Hide password"
                          : "Show password",
                        "aria-pressed": _vm.isPasswordVisible.toString(),
                        title: _vm.isPasswordVisible
                          ? "Hide password"
                          : "Show password",
                      },
                      on: { click: _vm.togglePasswordVisibility },
                    },
                    [
                      _vm.isPasswordVisible
                        ? _c(
                            "svg",
                            {
                              staticClass: "password-visibility-icon",
                              attrs: {
                                "aria-hidden": "true",
                                width: "40",
                                height: "38",
                                viewBox: "0 0 40 38",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  d: "M10 19.4179C10 19.4179 13.5496 13.4151 20 13.4151C26.4504 13.4151 30 19.4179 30 19.4179",
                                  stroke: "#0B3A59",
                                  "stroke-width": "1.6",
                                  "stroke-linejoin": "round",
                                },
                              }),
                              _vm._v(" "),
                              _c("path", {
                                attrs: {
                                  d: "M23.5837 19.4179C23.5837 21.3899 21.9793 22.9884 20 22.9884",
                                  stroke: "#0B3A59",
                                  "stroke-width": "1.6",
                                  "stroke-linejoin": "round",
                                },
                              }),
                              _vm._v(" "),
                              _c("path", {
                                attrs: {
                                  d: "M17.368 21.8435C16.776 21.2066 16.4141 20.3543 16.4141 19.4179C16.4141 17.4459 18.0185 15.8473 19.9977 15.8473C20.87 15.8473 21.6692 16.1578 22.2907 16.6739",
                                  stroke: "#0B3A59",
                                  "stroke-width": "1.6",
                                  "stroke-linejoin": "round",
                                },
                              }),
                              _vm._v(" "),
                              _c("path", {
                                attrs: {
                                  d: "M27.5473 12.3351L13.2812 25.6649",
                                  stroke: "#0B3A59",
                                  "stroke-width": "1.6",
                                  "stroke-linejoin": "round",
                                },
                              }),
                            ]
                          )
                        : _c(
                            "svg",
                            {
                              staticClass: "password-visibility-icon",
                              attrs: {
                                "aria-hidden": "true",
                                width: "40",
                                height: "38",
                                viewBox: "0 0 40 38",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  d: "M10 19.4768C10 19.4768 13.5496 13.4737 20 13.4737C26.4504 13.4737 30 19.4765 30 19.4765",
                                  stroke: "#0B3A59",
                                  "stroke-width": "1.6",
                                  "stroke-linejoin": "round",
                                },
                              }),
                              _vm._v(" "),
                              _c("path", {
                                attrs: {
                                  d: "M22.5357 22.0015C23.9352 20.6071 23.9352 18.3464 22.5357 16.952C21.1362 15.5576 18.8672 15.5576 17.4676 16.952C16.0681 18.3464 16.0681 20.6071 17.4676 22.0015C18.8672 23.3959 21.1362 23.3959 22.5357 22.0015Z",
                                  stroke: "#0B3A59",
                                  "stroke-width": "1.6",
                                  "stroke-linejoin": "round",
                                },
                              }),
                            ]
                          ),
                    ]
                  ),
                ]),
              ]),
            ]
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "small-12 columns" }, [
          _c("fieldset", { staticClass: "login-btn" }, [
            _c(
              "button",
              {
                staticClass: "btn btn--orange radius round",
                attrs: {
                  id: "modules-login-form-button-submit",
                  type: "submit",
                  disabled: _vm.isAdMock && _vm.disabled,
                },
                on: {
                  click: function () {
                    return _vm.submitForm()
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("login")))]
            ),
          ]),
        ]),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }